/* Tải file về máy KHÔNG mở cửa sổ mới.
   window.open() sau một lượt chờ (dựng PDF mất vài giây) không còn tính là "người dùng bấm" ⇒ trình duyệt chặn
   như popup. Ở đây tải bằng fetch rồi bấm một <a download> trỏ vào blob — trình duyệt coi là tải file, không chặn. */

function nameFrom(disposition: string | null, fallback: string): string {
  if (!disposition) return fallback;
  const star = /filename\*=UTF-8''([^;]+)/i.exec(disposition);
  if (star && star[1]) {
    try {
      return decodeURIComponent(star[1]);
    } catch {
      /* tên hỏng: dùng dạng thường */
    }
  }
  const plain = /filename="?([^";]+)"?/i.exec(disposition);
  return plain && plain[1] ? plain[1] : fallback;
}

export async function downloadFile(url: string, fallbackName = "apus-ami.pdf"): Promise<string> {
  if (!/^https?:\/\//i.test(url)) throw new Error("Đường dẫn tải không hợp lệ");
  const response = await fetch(url, { credentials: "omit" });
  if (!response.ok) {
    let message = "HTTP " + response.status;
    try {
      const body = (await response.json()) as { error?: { message?: string } };
      if (body.error?.message) message = body.error.message;
    } catch {
      /* thân không phải JSON */
    }
    throw new Error(message);
  }
  const blob = await response.blob();
  const name = nameFrom(response.headers.get("content-disposition"), fallbackName);
  const href = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = href;
  a.download = name;
  a.rel = "noopener";
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(href), 10000);
  return name;
}

/** Tải một nội dung chữ có sẵn (Markdown) thành file. */
export function downloadText(content: string, name: string, type = "text/markdown;charset=utf-8"): void {
  const href = URL.createObjectURL(new Blob([content], { type }));
  const a = document.createElement("a");
  a.href = href;
  a.download = name;
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(href), 10000);
}
